// extracted by mini-css-extract-plugin
export default {"slide":"SwiperSlide_slide__1717l","img":"SwiperSlide_img__cUyU2","info":"SwiperSlide_info__CuGlq","title":"SwiperSlide_title__qxkRW","artist":"SwiperSlide_artist__cind+"};